/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, tab: NonNullable<unknown> }} Validation_Toast_MultiInputs */

const cs_validation_toast_multi = /** @type {(inputs: Validation_Toast_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Formulář obsahuje ${i?.count} chyby. První je na záložce ${i?.tab}.`)
};

const en_validation_toast_multi = /** @type {(inputs: Validation_Toast_MultiInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The form has ${i?.count} errors. The first is on the ${i?.tab} tab.`)
};

/**
* | output |
* | --- |
* | "The form has {count} errors. The first is on the {tab} tab." |
*
* @param {Validation_Toast_MultiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_toast_multi = /** @type {((inputs: Validation_Toast_MultiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Toast_MultiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_toast_multi(inputs)
	return cs_validation_toast_multi(inputs)
});